module.exports = __webpack_public_path__ + "static/media/iom.6d7fbe8d.svg";